import "./index.scss";
import "./utils/fetchWrapper.js";

import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";

import { NODE_ENV } from "./config/envConfig";
import App from "./containers/app";
import { initDataDog } from "./externals/datadog";
import reportWebVitals from "./reportWebVitals";
import store from "./store";

if (["development", "staging", "uat", "production"].includes(NODE_ENV)) {
  initDataDog();
}

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Provider store={store}>
    <App />
  </Provider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

reportWebVitals();
